@if (notification.isEscalated && showEscalatedIcon) {
    <fa-icon [icon]="faExclamationTriangle" class="me-1 red"></fa-icon>
}
@if (notification.isCancelled && showCancelledIcon) {
    <fa-icon [icon]="faBan" class="me-1 red"></fa-icon>
}
@if (notification.isUnread && showUnreadIcon) {
    <fa-icon [icon]="faCircle" class="me-1 orange"></fa-icon>
}
@if (showBadge) {
    <span class="badge-text" [ngClass]="statusClass">{{ statusText }}</span>
}
